import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { Car } from 'app/models/car.model';
import { FastTaskProcessing } from 'app/models/fast-task-processing.model';
import { Poligon } from 'app/models/poligon.model';
import { CarService } from 'app/services/car.service';
import { FastTaskProcessingService } from 'app/services/fast-task-processing.service';
import { PoligonService } from 'app/services/poligon.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseFormComponent } from '../../base-form.component';

@Component({
    selector: 'fast-task-processing',
    templateUrl: './fast-task-processing.component.html',
    styleUrls: ['./fast-task-processing.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class FastTaskProcessingComponent extends BaseFormComponent implements OnInit {
    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    
    private _cars : Array<Car>;
    public get cars() : Array<Car> {
        return this._cars;
    }
    public set cars(v : Array<Car>) {
        this._cars = v;
    }
    
    private _polygons : Array<Poligon>;
    public get polygons() : Array<Poligon> {
        return this._polygons;
    }
    public set polygons(v : Array<Poligon>) {
        this._polygons = v;
    }

    
    private _fastTask : Array<FastTaskProcessing>;
    public get fastTask() : Array<FastTaskProcessing> {
        return this._fastTask;
    }
    public set fastTask(v : Array<FastTaskProcessing>) {
        this._fastTask = v;
    }
    
    public selectCar:Car;
    public selectPolygon:Poligon;
    public poligonTrashold:number;

    private _dataSource: MatTableDataSource<FastTaskProcessing> = undefined;
    public get dataSource(): MatTableDataSource<FastTaskProcessing> {
        return this._dataSource;
    }

    private _displayedColumns = ['plate', 'name','treshold','allContainer','fullContainer','emptyContainer'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    constructor(
        private _spinner:NgxSpinnerService,
        private _carService:CarService,
        private _toasterService:ToasterService,
        private _translateService:TranslateService,
        private _polygonService:PoligonService,
        private _fastTaskProcessingService:FastTaskProcessingService,
        private _dialog: MatDialog,
        private _toastService: ToasterService,
    ) {
        super()
    }

    public async ngOnInit() {
        await this.getCarList();
        await this.getPolygonList();
        await this.getFastTaskList();
        await this.updateTableDataSource();
    }

    public async getCarList() {
        try {
            this.cars = await this._carService.getCars(parseInt(localStorage.getItem('CompanyID')))
        } catch (error) {
            console.warn(error);
        }
    }

    public async getPolygonList() {
        try {
            this.polygons = await this._polygonService.getPoligons(parseInt(localStorage.getItem('CompanyID')))
        } catch (error) {
            console.warn(error);
        }
    }

    public async getFastTaskList(){
        try {
            this.fastTask = await this._fastTaskProcessingService.getFastTask(parseInt(localStorage.getItem('CompanyID')));
        } catch (error) {
            console.warn(error);
        }
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<FastTaskProcessing>(this._fastTask);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public async selectionPolygon(polygon:Poligon){
        this.poligonTrashold = polygon.treshold;
    }

    public async selectionCar(car:Car){
        this.selectPolygon = this.polygons.find(x=>x.id == car.polygonId);
        this.poligonTrashold = this.selectPolygon.treshold;
    }

    public async save(){

        if (this.form.invalid) {
            this._toasterService.toastWarning(this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY"));
            return;
        }

        this.selectCar.poligon = this.selectPolygon;
        this.selectCar.polygonId = this.selectPolygon.id;
        this.selectCar.poligon.treshold = this.poligonTrashold;
        
        try {
            var result = await this._fastTaskProcessingService.fastTaskUpdate(this.selectCar);
            if(result){
                this._toastService.toastSuccess()
            }
        } catch (error) {
            console.warn(error);
            this._toastService.toastFail();
        }
    }
}
